const API_BASE = "https://ljp.linklanka.lk";

export default API_BASE;



//Live = "https://ljp.linklanka.lk/",
//Test = "http://ljp2.linklanka.lk/",